// extracted by mini-css-extract-plugin
export default {"dot":"PaginationDot_dot__WtQlv","active":"PaginationDot_active__-hnlt"};